import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgView2DRing = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.3027 4.10645C17.1013 4.72862 20 8.02538 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 8.02571 6.89817 4.72902 10.6963 4.10645L12 1.5L13.3027 4.10645ZM12 4.5C7.85786 4.5 4.5 7.85786 4.5 12C4.5 16.1421 7.85786 19.5 12 19.5C16.1421 19.5 19.5 16.1421 19.5 12C19.5 7.85786 16.1421 4.5 12 4.5Z",
		fill: "black"
	})
});
export default SvgView2DRing;
